<template>
  <div>
    <span :class="{ 'text-left': true, required: required }">
      {{ label }}
    </span>
    <v-autocomplete
      :items="items"
      v-model="selectedValue"
      :class="{ 'input-control': true }"
      hide-details
      dense
      outlined
    ></v-autocomplete>
  </div>
</template>

<script>
export default {
  name: "LabelTextField",
  props: {
    label: String,
    placeholder: String,
    required: Boolean,
    items: Array
  },
  data() {
    return {
      selectedValue: "",
    };
  },
  watch: {
    selectedValue: function() {
      this.$emit("change", this.selectedValue);
    },
  },
};
</script>

<style scoped>
span {
  display: flex;
  font-size: 0.75rem;
  font-weight: bold;
  color: #b0bac9;
  padding-bottom: 0.5rem;
}

.required::after {
  content: "*";
  margin-left: 0.25rem;
  color: red;
}

.unit {
  width: 3.25rem;
  height: 1.875rem;
  padding-bottom: 0;
  border: 1px solid #e0e7ff;
  border-radius: 0.3125rem;
  background: white;
}

.unit span {
  font-size: 1.125rem;
  font-weight: 500;
  color: #7b7b7b;
}
</style>
